import React, { useState } from 'react';
import moment from 'moment';
import TablePagination from "../../../../utils/components/TablePagination";
import LoadingOverlay from "../../../../utils/components/LoadingOverlay";

const TransactionsSummary = ({ transactions, loading }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);
    const [searchTerm, setSearchTerm] = useState("");

    const formatCurrency = (value) => {
        return Number(value).toLocaleString("de-DE", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
    };

    // Filter Logic
    let filteredTransactions = transactions || [];
    if (searchTerm) {
        const lowerSearch = searchTerm.toLowerCase();
        filteredTransactions = filteredTransactions.filter(tx =>
            tx.transaction_name?.toLowerCase().includes(lowerSearch) ||
            tx.origin_info?.name?.toLowerCase().includes(lowerSearch)
        );
    }

    // Pagination
    const totalItems = filteredTransactions.length;
    const paginatedTransactions = filteredTransactions.slice(currentPage * pageSize, (currentPage + 1) * pageSize);

    return (
        <LoadingOverlay loading={loading}>
        <div className="ibox float-e-margins" style={{ border: 'none', borderRadius: '15px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
            <div className="ibox-title" style={{ border: 'none', padding: '20px 25px 0 25px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h5 style={{ fontSize: '18px', margin: 0 }}>Historial de Transacciones Globales</h5>
                    <div className="input-group" style={{ width: '250px' }}>
                        <span className="input-group-addon" style={{ backgroundColor: '#f3f3f4', border: 'none' }}>
                            <i className="fa fa-search text-muted"></i>
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar por concepto u origen..."
                            value={searchTerm}
                            style={{ backgroundColor: '#f3f3f4', border: 'none', boxShadow: 'none' }}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(0);
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="ibox-content" style={{ border: 'none', padding: '25px' }}>
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Concepto</th>
                                <th>Origen</th>
                                <th className="text-right">Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedTransactions.map((tx, idx) => {
                                const isPositive = tx.amount > 0;
                                return (
                                    <tr key={idx}>
                                        <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                            <div style={{ fontWeight: '500' }}>{moment(tx.date_and_time).format('DD/MM/YYYY')}</div>
                                            <div style={{ fontSize: '11px', color: '#888' }}>{moment(tx.date_and_time).format('HH:mm')}</div>
                                        </td>
                                        <td style={{ verticalAlign: 'middle' }}>
                                            <span style={{ fontWeight: '500', color: '#676a6c' }}>{tx.transaction_name}</span>
                                        </td>
                                        <td style={{ verticalAlign: 'middle' }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <i className={`fa ${tx.origin_info?.type === 'user' ? 'fa-user' : 'fa-shield'} text-muted m-r-xs`}></i>
                                                <span>{tx.origin_info?.name || 'N/A'}</span>
                                            </div>
                                        </td>
                                        <td className="text-right" style={{ verticalAlign: 'middle' }}>
                                            <span style={{
                                                fontWeight: 'bold',
                                                color: isPositive ? '#1ab394' : '#ed5565',
                                                fontSize: '14px'
                                            }}>
                                                {isPositive ? '+' : ''}${formatCurrency(tx.amount)} {tx.currency}
                                            </span>
                                        </td>
                                    </tr>
                                )
                            })}
                            {paginatedTransactions.length === 0 && (
                                <tr>
                                    <td colSpan="4" className="text-center p-md text-muted">No se encontraron transacciones.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {totalItems > pageSize && (
                    <div className="m-t-md text-center">
                        <TablePagination
                            defaultPage={currentPage}
                            defaultPageSize={pageSize}
                            totalItems={totalItems}
                            itemsInPage={paginatedTransactions.length}
                            onChangePage={(p) => setCurrentPage(p)}
                        />
                    </div>
                )}
            </div>
        </div>
        </LoadingOverlay>
    );
};

export default TransactionsSummary;
